<template>
  <div class="left-table-list" >
    <div class="order-table-toolbar">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24" style="width: 100%">
            <div style="overflow: hidden;display: flex;margin-top: 0px" class="table-page-search-submitButtons">
              <div>
                <a-button type="primary" @click="newPlatform" icon="plus-circle"
                          style="height: 36px !important;border-radius: 18px;font-size: 14px">绑定平台</a-button>
              </div>
              <div class="common-btn-box" >
<!--                <div class="common-btn-box-span" @click="newPlatform">-->
<!--                  <icon-font class="common-btn-icon" type="icon-xinzeng"></icon-font>-->
<!--                  <span>绑定平台</span>-->
<!--                </div>-->
<!--                <a-divider class="common-btn-divider" v-has="'driver:del'" type="vertical" v-show="selectedRowKeys.length"/>-->
                <div class="common-btn-box-span" @click="clearSupper" v-show="!selectedRowKeys.length">
                  <icon-font class="common-btn-icon" type="icon-shuaxin"></icon-font>
                  <span>重新加载</span>
                </div>
                <a-divider class="common-btn-divider" type="vertical" v-show="!selectedRowKeys.length"/>
                <div class="common-btn-box-span" v-has="'driver:del'" @click="batchDel" v-show="selectedRowKeys.length">
                  <icon-font class="common-btn-icon" type="icon-shanchu-copy"></icon-font>
                  <span>删除</span>
                </div>
              </div>
              <div class="car-more-box" v-if="dataSource && dataSource.length">
                <img :src="getFileAccessHttpUrl(dataSource[0].updateByAvatar)" v-if="dataSource[0].updateByAvatar"/>
                <span>{{dataSource[0].updateByName}}</span>
                <span>更新于{{dataSource[0].updateTime}}</span>
              </div>
              <div class="car-more-box" v-else>

              </div>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div>
  <a-table
    ref="table"
    size="middle"
    :scroll="{x:1200}"
    rowKey="id"
    :columns="columns"
    :dataSource="dataSource"
    :pagination="ipagination"
    :loading="loading"
    :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,fixed:true}"
    :customHeaderRow="customHeaderRow"
    :customRow="customRow"
    class="j-table-force-nowrap"
    @change="handleTableChange">

    <template slot="bdSlot" slot-scope="text,record">
      <div>
        <span v-if="text==0">已绑定</span>
        <span v-if="text==1">已解绑</span>
      </div>
    </template>

    <template slot="platformNameSlot" slot-scope="text,record">
      <div>
        <img v-if="record.logo" :title="text" :src="getImgView(record.logo)"  alt="" style="width:24px;height: 24px;font-size: 12px;font-style: italic;border-radius:3px"/>
        <span :style="{marginLeft: record.logo?'6px':''}">{{text && text.length>6?text.substring(0,6)+'...':text}}</span>
      </div>
    </template>
    <template slot="createByName" slot-scope="text, record">
      <span >
              <img :title="text" v-if="record.createAvatar" :src="getImgView(record.createAvatar)" height="25px" alt="" style="width:20px;height:20px;font-size: 12px;font-style: italic;border-radius:50%"/>
              <span style="width: 20px;display: inline-block" v-else></span>
              <span style="margin-left: 10px" :title="text">{{text}}</span>
      </span>
    </template>
    <template slot="realname" slot-scope="text, record">
      <span >
              <img :title="text" v-if="record.avatar" :src="getImgView(record.avatar)" height="25px" alt="" style="width:20px;height:20px;font-size: 12px;font-style: italic;border-radius:50%"/>
              <span style="width: 20px;display: inline-block" v-else></span>
              <span style="margin-left: 10px" :title="text">{{text}}</span>
      </span>
    </template>
    <span slot="action" slot-scope="text, record">
            <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a class="tb-span-click"  v-has="'driver:del'">删除</a>
                </a-popconfirm>
        </span>
  </a-table>
  <platform-modal-info ref="driverPlatfromInfo" @ok="callbackOk"></platform-modal-info>
</div>
  </div>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { getFileAccessHttpUrl,deleteAction } from '@/api/manage'
  import PlatformModalInfo from "@views/dm5/PlatformModalInfo";
  export default {
    name: 'PlatformTable',
    components: {PlatformModalInfo},
    mixins:[JeecgListMixin, mixinDevice],
    props: {
      driverId:{
        type:Number,
        default:''
      },
      model:{
        type:Object,
        default:{}
      }
    },data(){
      return {
        columns: [
          {
            title: '所属平台',
            dataIndex: 'platformName',
            align:"left",
            scopedSlots: { customRender: 'platformNameSlot' },
            width:150,
            ellipsis: true
          },{
            title: '当前状态',
            dataIndex: 'currentStatus_dictText',
            align:"left",
            width:140,
            ellipsis: true
          },{
            title: '备注',
            dataIndex: 'remark',
            align:"left",
            width:200,
            ellipsis: true
          },{
            title: '识别号',
            dataIndex: 'identificationNumber',
            align:"left",
            key: 'identificationNumber',
            customRender:function (t,r,index) {
              return t || '-';
            },
            width:180,
            ellipsis: true
          },{
            title: '所属车队',
            dataIndex: 'teamName',
            align:"left",
            key: 'teamName',
            width:180,
            ellipsis: true
          },{
            title: '所属队长',
            dataIndex: 'realname',
            align:"left",
            key: 'realname',
            width:140,
            ellipsis: true,
            scopedSlots: { customRender: 'realname' }
          },{
            title: '首次注册时间',
            dataIndex: 'regTime',
            align:"left",
            key: 'regTime',
            customRender:function (t,r,index) {
              return t || '-';
            },
            width:180,
            ellipsis: true
          },
          {
            title: '操作人',
            align:"left",
            dataIndex: 'createByName',
            width:140,
            ellipsis: true,
            scopedSlots: { customRender: 'createByName' }
          },
          {
            title: '操作时间',
            align:"left",
            dataIndex: 'bdTime',
            customRender:function (t,r,index) {
              return t || '-';
            },  width:180,
            ellipsis: true
          },
          // {
          //   title: '操作',
          //   dataIndex: 'action',
          //   align:"left",
          //   width:140,
          //   fixed:"right",
          //   scopedSlots: { customRender: 'action' }
          // }
        ],
        url: {
          list: "/dm/dmDriverPlatform/list",
          delete: "/dm/dmDriverPlatform/delete",
          deleteBatch: "/dm/dmDriverPlatform/deleteBatch",
        },disableMixinCreated:true,
        getFileAccessHttpUrl:getFileAccessHttpUrl,
        windowHeight:window.innerHeight-356
      }
    },methods:{
      loadList(){
        this.queryParam.driverId = this.driverId;
        this.queryParam.type =0;
        this.loadData();
      },callbackOk(){
        this.loadList();
        this.$emit("ok");
      },bdPlatform(){
        this.$refs.driverPlatfromInfo.edit({driverId:this.driverId});
      },viewInfo(record){
        this.$refs.driverPlatfromInfo.showInfo(record.id);
      },deletePlatform(record){
        let that = this;
        deleteAction("/dm/dmDriverPlatform/delete", {id: record.id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.callbackOk();
          } else {
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.loading = false;
        });
      },newPlatform(){
        this.$refs.driverPlatfromInfo.addPlatform(this.driverId);
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';
  @import '~@assets/less/dm/tableList.less';
  @import '~@assets/less/dm/newTable.less';
  /deep/ th[key='selection-column']{
    padding: 12px 22px !important
  }
  .left-table-list{
    margin-top: 0 !important;
  }
  .car-more-box{
    width: 376px;
    background: #fff;
    border-radius: 18px;
    padding:7px 18px;
  }
  .car-more-box img{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    vertical-align: sub;
  }
  .car-more-box span{
    margin-left: 9px;
  }
</style>